import { z } from 'zod';

/** DELETE /api/delete-jobs/appci/{orch_appci_id} のレスポンス */
export const DeleteAppCIJobResponseSchema = z.object({
  job_id: z.string(),
  request_id: z.string().nullable(),
  status: z.string(),
});

/** AppCI 削除ジョブ開始レスポンスの型 */
export type DeleteAppCIJobResponse = z.infer<
  typeof DeleteAppCIJobResponseSchema
>;